// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import api from './api/api.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueCookies from 'vue-cookies'
import moment from "moment"
ElementUI.Dialog.props.lockScroll.default = false;




Vue.prototype.$api = api;
Vue.prototype.$moment = moment;
Vue.use(ElementUI);
Vue.use(VueCookies)



Vue.config.productionTip = false

// 页面级SEO：每个路由切换时，动态更新页面 title / description / keywords
router.afterEach((to) => {
  if (to.meta && to.meta.title) document.title = to.meta.title
  if (to.meta && to.meta.desc) {
    const m = document.querySelector('meta[name="description"]')
    if (m) m.setAttribute('content', to.meta.desc)
  }
  if (to.meta && to.meta.kw) {
    const k = document.querySelector('meta[name="keywords"]')
    if (k) k.setAttribute('content', to.meta.kw)
  }
  // 保留百度统计的单页浏览记录
  if (window._hmt) {
    try { window._hmt.push(['_trackPageview', to.fullPath]) } catch (e) {}
  }
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js